import React from 'react';

const MissionSection = () => {
  const missionItems = [
    {
      title: "Connection",
      description: "Bring people closer together through shared plans and lasting memories."
    },
    {
      title: "Discovery",
      description: "Open the door to new music, new events, and new experiences."
    },
    {
      title: "Memories",
      description: "Build a living record of every gig, festival, and moment that matters."
    },
    {
      title: "Simplicity",
      description: "Make every part of going to events easier, with everything in one place."
    }
  ];

  return (
    <section id="mission" className="py-14 md:py-24 bg-white">
      <div className="container mx-auto max-w-7xl px-6 md:px-6">
        {/* Section Header */}
        <div className="flex flex-col gap-6 text-center mb-16">
          <h2 className="text-[36px] md:text-[48px] font-semibold text-black leading-tight font-['Space_Grotesk']">
            Live music has always been where we find joy, connection, and unforgettable moments.
          </h2>
          <p className="text-[20px] md:text-[24px] font-light text-gray-700 max-w-4xl mx-auto leading-relaxed">
            So we started Antix to build an app that enhances the experience instead of getting in the way, focusing on what truly matters to music lovers.
          </p>
        </div>

        {/* Four Column Grid */}
        <div className="mt-12 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {missionItems.map((item, index) => (
            <div className="flex flex-col gap-4" key={index}>
              <h4 className="text-2xl md:text-3xl font-semibold text-black font-['Space_Grotesk']">
                {item.title}
              </h4>
              <p className="text-lg text-gray-700 leading-relaxed opacity-75">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;